// src/js-dot/rx/view/classes/rx-class-switch.ts
import { checkSubscription } from "@js-dot/rx";
import { ClassSwitch } from "@js-dot/ui";
import { Observable } from "rxjs";
var RxClassSwitch = class extends ClassSwitch {
  _subscription;
  set(className) {
    if (!(className instanceof Observable)) {
      return super.set(className);
    }
    this._subscription = checkSubscription(this._subscription, className.subscribe(className2 => {
      if (this._classList) {
        this._set(className2);
      } else {
        this._subscription.unsubscribe();
      }
    }));
    return this;
  }
  // protected override _set(classNames: string | string[]) {
  // 	const {_prefix, _lastClassName, _classList} = this;
  //
  // 	const prefix = _prefix ? _prefix : '';
  //
  // 	classNames = Array.isArray(classNames) ?
  // 		prefix + classNames.join(prefix + ' ') :
  // 		prefix + classNames;
  //
  // 	this.pop();
  // 	this._lastClassName = classNames;
  //
  // 	if (!classNames) {
  // 		return this;
  // 	}
  //
  // 	_classList.add(...classNames.split(' '));
  //
  // 	return this;
  // }
  // override pop() {
  // 	if (!this._lastClassName) {
  // 		return;
  // 	}
  //
  // 	this._classList.remove(...this._lastClassName.split(' '));
  // }
};

// src/js-dot/rx/view/classes/rx-class-toggle.ts
import { checkSubscription as checkSubscription2 } from "@js-dot/rx";
import { ClassToggle } from "@js-dot/ui";
import { Observable as Observable2 } from "rxjs";
var RxClassToggle = class extends ClassToggle {
  _subscription;
  set(flag = false) {
    if (flag instanceof Observable2) {
      this._subscription = checkSubscription2(this._subscription, flag.subscribe(flag_ => {
        if (this._classList) {
          this.enable(flag_);
        } else {
          this._subscription.unsubscribe();
        }
      }));
      return this;
    }
    return super.set(flag);
  }
};
export { RxClassSwitch, RxClassToggle };
